<template>
  <div class="" v-if="$store.state.user != null">
    <div class="" v-if="broker != null">
      <DesktopHeader />
      <SubHeader></SubHeader>

      <div class="flex flex-wrap w-full px-6 xxl:px-0 xxl:w-3/5 m-auto mt-10">
        <template v-if="displayNavigation">
          <div class="hidden lg:block lg:w-1/5">
            <Navigation></Navigation>
          </div>
          <div class="w-full lg:w-4/5 pl-0 lg:pl-10">
            <router-view></router-view>
          </div>
        </template>

        <template v-else>
          <div class="w-full">
            <router-view></router-view>
          </div>
        </template>
      </div>

      <Notification></Notification>
      <ContentLoader v-bind:loaderData="loaderData"></ContentLoader>
      <MapModal />
      <SuspendedModal />
    </div>
  </div>
</template>

<script>
  import { EventBus }       from '@/shared/event-bus';
  import InvalidPage        from "@/views/InvalidPage"
  import Navigation         from "@/shared/components/navigation/Home"
  import DesktopHeader      from "@/shared/components/headers/DesktopHeader"
  import SubHeader          from "@/shared/components/headers/SubHeader"
  import Notification       from "@/shared/components/Notification"
  import ContentLoader      from '@/shared/components/loaders/ContentLoader'
  import MapModal           from '@/shared/components/modals/MapModal'
  import SuspendedModal     from '@/shared/components/modals/SuspendedModal'

  export default {

    components: {
      DesktopHeader,
      SubHeader,
      ContentLoader,
      Navigation,
      Notification,
      InvalidPage,
      MapModal,
      SuspendedModal
    },

    data() {
      return {
        broker    : null,
        loaderData: {
          display : false
        },
      }
    },

    mounted() {
      EventBus.$on('set-content-loading', loaderData => {
        this.loaderData = loaderData
      });

      window.addEventListener('storage', (e) => {
        var ls = localStorage.getItem('bp-broker-jwt')
        if(ls == null) {
          alert('Your current session has expired. Please login again.')
          this.$router.push({ name : 'auth-login' })
        }
      });
    },

    destroyed() {
      EventBus.$off('set-content-loading')
      window.removeEventListener('storage', () => {

      })
    },

    created() {
      this.getUser({
        force : true
      }, (user) => {

        // if this user is broker, then grab the broker details
        if(user.role == 1) {
          this.$store.commit("setView", "broker")
          this.getBroker({
            userId: user.id,
          }, (broker) => {

            this.broker = broker
            if(this.$route.name == 'home') {
              this.$router.push({ 
                name  : 'broker-home' 
              })
            }
          })
        }

        // if key is missing, that means the client has already landed via email
        // and then went to another page and we are now refreshing.
        // So the user should be logged in and all data should be in there
        else {
          this.broker = user.broker
          this.$store.commit("setView", "client")
          this.$store.commit("clientModule/setBroker", user.broker)

          if(this.$route.name == 'home') {
            this.$router.push({ 
              name  : 'client-home',
              params: {
                clientId: user.client.id
              }
            })
          }
        }
      })
    },

    computed : {
      displayNavigation() {
        if(this.$route.path.indexOf('/application/') > -1 ||
           this.$route.path.indexOf('/help/') > -1 ||
           this.$route.name == 'client-activity' ||
           this.$store.state.view == 'client' ||
           (this.$route.path.indexOf('/broker/') > -1 && this.$route.path.indexOf('/broker/home') == -1 && this.$route.path.indexOf('/broker/list') == -1) || 
           (this.$route.path.indexOf('/planner/') > -1 && this.$route.path.indexOf('/planner/home') == -1 && this.$route.path.indexOf('/planner/list') == -1)) {
          return true
        }

        return false
      }
    }
  }
</script>